<div style="text-align: center;">
  <div style="color: white; margin-bottom: 0.5rem;">
      <span [innerHTML]="errorMessage"></span>
  </div>
  <div>
    <a [href]="myItDigitalAssistant" target="_blank" rel="noopener" class="btn btn-link">
      {{ assistantText }}
    </a> <br>
    <a [href]="reportAnIncident" target="_blank" rel="noopener" class="btn btn-link">
      {{ incidentText }}
    </a>
  </div>
</div>